export const defaultSelectedHallazgo = () => {
    return {
        id_empresa: '',
        id_lista_chequeo: '',
        id_base: '',
        id_area: '',
        id_tipo_seguimiento: '',
        id_item: '',
        cumple: '',
        observaciones: '',
        opciones_mejora: '',
    }
}
export const defaultSelectedListaChequeo = () => {
    return {
        id_tipo_lista_chequeo: '',
        id_empresa: '',
        unidad_negocio: '',
        fecha_inicio_visita: '',
        fecha_cierre_visita: '',
        responsable: '',
        ubicacion: '',
        proximo_seguimiento: '',
        observacion_general: '',
    }
}


export default {
    selectedListaChequeo: defaultSelectedListaChequeo(),
    selectedHallazgo: defaultSelectedHallazgo(),


    mostrarEditar: true,
    accion: 'Crear',
    listaChequeo: [],

    tipoSeguimientos: [],
    items: [],
    hallazgos: [],
    empresas: [],
    error: false,

    filtro: {
        id_empresa: '',
        page: 1,
        perPage: 10,
        sortBy: 'id_tipo_seguimiento',
        sort: 'DESC',
    },



}
